import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../state/store";
import { getListAction } from "../../../../state/usecase/admin/care_comment_analysis/actions";
import { CareCommentAnalysisDataMenu } from "./components/CareCommentAnalysisDataMenu";
import { CareCommentAnalysisDataTable } from "./components/CareCommentAnalysisDataTable";

export const CareCommentAnalysisPage = React.memo(function CareCommentAnalysisPage() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getListAction());
    }, [dispatch]);

    return (
        <div className={"admin_care_comment_analysis_page"}>
            {/* ページタイトル */}
            <div className={"header"}>
                ケアコメント分析
            </div>
            {/* ページコンテンツ */}
            <div className={"container"}>
                <CareCommentAnalysisDataMenu />
                {/* 分析データのテーブル */}
                <CareCommentAnalysisDataTable />
            </div>
        </div>
    );
});